import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  Grid
} from "@mui/material";
import { sanitizeAnnounceHtml } from "common/functions/security";
import { DialogHeader } from "components/Parts/Atoms/DialogHeader";
import { LevelChip } from "components/Parts/Atoms/LevelChip";
import React from "react";
import { ProgressBackdrop } from "../../Molecules/ProgressBackdrop";
import styles from "./AnnounceDialog.module.scss";
import { useAnnounceDialogDialogHooks } from "./hooks";
import { AnnounceDialogDialogProps as AnnounceDialogProps } from "./interfaces";

const idPrefix = "announce-dialog";

export const AnnounceDialog = React.memo((props: AnnounceDialogProps) => {
  const {
    announce,
    errorMessage,
    busy,

    onOkButtonClick,
    nodeRef
  } = useAnnounceDialogDialogHooks(props);

  if (props.open) {
    return (
      <Dialog
        open={props.open}
        aria-labelledby={`${idPrefix}-title`}
        aria-describedby={`${idPrefix}-description`}
        maxWidth={false}
        ref={nodeRef}
        className={styles.announceDialog}
        slotProps={{
          paper: { className: styles.dialogPaper },
          backdrop: { className: styles.backdrop }
        }}
      >
        <Collapse in={errorMessage !== ""}>
          <Alert severity="error" className={styles.alert}>
            <AlertTitle>エラーが発生しました！</AlertTitle>
            {errorMessage}
          </Alert>
        </Collapse>
        <DialogHeader
          id={`${idPrefix}-title`}
          icon={
            <Box className={styles.headerIcon}>
              <AnnouncementOutlinedIcon />
            </Box>
          }
        />
        <DialogContent
          id={`${idPrefix}-description`}
          className={styles.content}
        >
          <Grid container rowSpacing={2} className={styles.container}>
            <Grid size={12}>
              <Box className={styles.subject}>
                <LevelChip level={announce?.level ?? undefined} />
                {announce?.subject}
              </Box>
              <Box className={styles.createdAt}>
                {announce?.createdAt
                  ? new Date(announce.createdAt)
                      .toLocaleDateString("ja-JP")
                      .split("/")
                      .map((v) => v.padStart(2, "0"))
                      .join("/")
                  : "----/--/--"}
              </Box>
              <Box
                component="div"
                dangerouslySetInnerHTML={{
                  __html: sanitizeAnnounceHtml(announce?.body ?? "")
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={styles.actions}>
          <Button
            className={`${styles.button} ${styles.ok}`}
            fullWidth
            variant="contained"
            disabled={busy}
            onClick={onOkButtonClick}
          >
            閉じる
          </Button>
        </DialogActions>
        <ProgressBackdrop open={busy || props.busy || false} />
      </Dialog>
    );
  } else {
    return null;
  }
});
